(function(){
  'use strict';

  function getImgUrl(el){
    if(!el) return '';
    if(el.currentSrc && el.currentSrc.indexOf('data:') === -1) return el.currentSrc;
    if(el.src && el.src.indexOf('data:') === -1) return el.src;
    var a = el.getAttribute('src');
    if(a && a.indexOf('data:') === -1) return a;
    var ss = (el.getAttribute('srcset')||el.srcset||'');
    if(ss) return ss.split(',')[0].trim().split(' ')[0];
    return '';
  }

  function getProductImage(){
    var sels = [
      'media-gallery .product__media img',
      '.product__media img',
      '.product__media-wrapper img',
      '[id^="GalleryViewer"] img',
    ];
    for(var i=0;i<sels.length;i++){
      var els = document.querySelectorAll(sels[i]);
      for(var j=0;j<els.length;j++){
        var el = els[j];
        if(el.closest('.thumbnail-list')||el.closest('.product-media-modal')) continue;
        var r = el.getBoundingClientRect();
        if(r.width<40||r.height<40) continue;
        var url = getImgUrl(el);
        if(url) return {url:url, rect:r};
      }
    }
    return null;
  }

  function getCartIcon(){
    return document.getElementById('cart-icon-bubble') ||
           document.querySelector('.header__icon--cart') ||
           document.querySelector('a[href="/cart"]');
  }

  function flyToCart(imgData, cartEl){
    var ir = imgData.rect, cr = cartEl.getBoundingClientRect();
    if(!ir.width||!cr.width) return;
    var size = Math.min(ir.width, ir.height, 110);
    var clone = document.createElement('img');
    clone.src = imgData.url;
    Object.assign(clone.style,{
      position:'fixed', pointerEvents:'none', zIndex:'2147483647',
      borderRadius:'8px', objectFit:'cover',
      boxShadow:'0 4px 20px rgba(0,0,0,0.35)',
      transition:'none', willChange:'transform,opacity',
      width:size+'px', height:size+'px',
      left:(ir.left+ir.width/2-size/2)+'px',
      top:(ir.top+ir.height/2-size/2)+'px',
    });
    document.body.appendChild(clone);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){
      Object.assign(clone.style,{
        transition:'all 0.75s cubic-bezier(0.4,0,0.2,1)',
        width:'42px', height:'42px',
        left:(cr.left+cr.width/2-21)+'px',
        top:(cr.top+cr.height/2-21)+'px',
        borderRadius:'50%', opacity:'0.85',
      });
      setTimeout(function(){
        clone.style.transition='opacity 0.2s';
        clone.style.opacity='0';
        var t = cartEl.querySelector('.svg-wrapper')||cartEl;
        t.classList.add('lido-cart-bounce');
        setTimeout(function(){ t.classList.remove('lido-cart-bounce'); },700);
        setTimeout(function(){ clone.remove(); },220);
      },760);
    });});
  }

  // Un solo listener: click sul bottone ATC
  // Nessun cooldown, nessun fetch intercept
  document.addEventListener('click', function(e){
    var btn = e.target.closest('button[name="add"]') ||
              e.target.closest('product-form [type="submit"]');
    if(!btn || btn.disabled) return;
    var imgData = getProductImage();
    var cart    = getCartIcon();
    if(imgData && cart) flyToCart(imgData, cart);
  }, true);

})();
